import searchService from '../../services/search';

const types = {
  GET_SEARCH_KEYWORD: 'searchService/getSearchKeyword',
  GET_SEARCH_KEYWORD_TOTAL: 'searchService/getSearchKeywordTotal',
};

const state = {
  videoSearchData: [],
  videoSearchTotal: 0,
};

const getters = {
  getSearchVideo: s => s.videoSearchData,
  getSearchVideoTotal: s => s.videoSearchTotal,
};

const actions = {
  searchKeyword({ commit }, query) {
    
    searchService
    .getSearchVideo(query)
    .then((res) => {

      const {
        data,
        total_pages,
      } = res;

      commit(types.GET_SEARCH_KEYWORD_TOTAL, total_pages);
      commit(types.GET_SEARCH_KEYWORD, data);

    })
    .catch(() => {

    });
  },
};

const mutations = {
  [types.GET_SEARCH_KEYWORD](s, d) {
    s.videoSearchData = d;
  },
  [types.GET_SEARCH_KEYWORD_TOTAL](s, d) {
    s.videoSearchTotal = d;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/search.js